import React from 'react';
import IconButton from '../../../icon-button';
const ClearButton = (props) => {
  const {
    selectProps: { isDisabled, onClear },
    innerProps,
  } = props;

  const handleMouseDown = (event) => {
    innerProps.onMouseDown?.(event);
    onClear?.();
  };

  return (
    <div {...innerProps} className="ws-ui-base-select__clear-button">
      <IconButton
        disabled={isDisabled}
        onMouseDown={handleMouseDown}
        glyph="clear-search"
        size="medium"
        transparent
      />
    </div>
  );
};

export default ClearButton;
